import { LINE_TYPES } from '../firebase/schema';

// Categorical palette for line types. Chosen to stay perceptually distinct from
// the existing status palette (orange / dodger blue / pale blue / pale green /
// lavender / gold) and from each other on the dark UI.
//
// Screen Print -> Coral   (warm pink-red, the "classic" workhorse)
// DTF          -> Fuchsia (vivid magenta, modern digital film)
// DTG          -> Teal    (cool cyan-green, digital inkjet feel)
// Embroidery   -> Bronze  (warm desaturated thread tone)
// Design Only  -> Slate   (neutral; mostly used as a placeholder)
export const LINE_TYPE_COLORS = {
  [LINE_TYPES.SCREEN_PRINT]: '#FB7185',
  [LINE_TYPES.DTF]: '#D946EF',
  [LINE_TYPES.DTG]: '#2DD4BF',
  [LINE_TYPES.EMBROIDERY]: '#B08968',
  [LINE_TYPES.DESIGN_ONLY]: '#94A3B8'
};

// Stable display order so badges line up the same way across every row.
export const LINE_TYPE_DISPLAY_ORDER = [
  LINE_TYPES.SCREEN_PRINT,
  LINE_TYPES.DTF,
  LINE_TYPES.DTG,
  LINE_TYPES.EMBROIDERY,
  LINE_TYPES.DESIGN_ONLY
];

// Short labels can be used inside a chip badge if/when we want letters in
// addition to color.
export const LINE_TYPE_SHORT_LABELS = {
  [LINE_TYPES.SCREEN_PRINT]: 'SP',
  [LINE_TYPES.DTF]: 'DTF',
  [LINE_TYPES.DTG]: 'DTG',
  [LINE_TYPES.EMBROIDERY]: 'EMB',
  [LINE_TYPES.DESIGN_ONLY]: 'D'
};

// Normalize whatever shape line.type comes in as (DB lowercase, display value,
// legacy aliases) into a canonical LINE_TYPES value.
export const normalizeLineType = (type) => {
  if (!type) return null;
  const t = String(type).trim().toLowerCase();
  if (t === 'screen' || t === 'screen print') return LINE_TYPES.SCREEN_PRINT;
  if (t === 'embroidery') return LINE_TYPES.EMBROIDERY;
  if (t === 'dtg') return LINE_TYPES.DTG;
  if (t === 'dtf') return LINE_TYPES.DTF;
  if (t === 'design_only' || t === 'design only') return LINE_TYPES.DESIGN_ONLY;
  if (Object.values(LINE_TYPES).includes(type)) return type;
  return null;
};

export const getLineTypeColor = (type) => {
  const normalized = normalizeLineType(type);
  return normalized ? LINE_TYPE_COLORS[normalized] : 'rgba(255, 255, 255, 0.3)';
};

export const getLineTypeShortLabel = (type) => {
  const normalized = normalizeLineType(type);
  return normalized ? LINE_TYPE_SHORT_LABELS[normalized] : '?';
};

// Sort a set/array of normalized line types into LINE_TYPE_DISPLAY_ORDER.
export const sortLineTypes = (types) => {
  const arr = Array.from(types || []);
  return arr.sort(
    (a, b) =>
      LINE_TYPE_DISPLAY_ORDER.indexOf(a) - LINE_TYPE_DISPLAY_ORDER.indexOf(b)
  );
};
